<div class="panel" [ngClass]="{ pin: pinned, open: isOpened }">
  <div class="data-wrapper">
    <ng-container *ngIf="!isLoading">
      <dx-toolbar class="panel-toolbar">
        <dxi-item location="before">
          <span class="contact-name value">{{ formData.name }}</span>
        </dxi-item>
        <dxi-item location="before">
          <contact-status [value]="formData.status"></contact-status>
        </dxi-item>
        <dxi-item location="after" [visible]="isPinEnabled">
          <dx-button
            stylingMode="text"
            [icon]="pinned ? 'pin' : 'unpin'"
            (onClick)="onPinClick()"
          ></dx-button>
        </dxi-item>
        <dxi-item location="after">
          <dx-button
            icon="close"
            stylingMode="text"
            (onClick)="onClosePanel()"></dx-button>
        </dxi-item>
      </dx-toolbar>

      <dx-scroll-view class="panel-scroll">
        <dx-validation-group>
          <div class="data-part border">
            <dx-form
              class="plain-styled-form"
              labelMode="floating"
              [class.view-mode]="!isEditing"
            >
              <dxi-item itemType="group" [colCount]="2" cssClass="photo-row">
                <dxo-col-count-by-screen [xs]="2"></dxo-col-count-by-screen>
                <dxi-item cssClass="photo-box">
                  <div *dxTemplate>
                    <form-photo [link]="formData.image"></form-photo>
                  </div>
                </dxi-item>

                <dxi-item itemType="group">
                  <dxi-item cssClass="accent">
                    <div *dxTemplate>
                      <form-textbox
                        label="Company"
                        [(value)]="formData.company"
                        [isEditing]="isEditing"
                      ></form-textbox>
                    </div>
                  </dxi-item>

                  <dxi-item>
                    <div *dxTemplate>
                      <form-textbox
                        label="Position"
                        [(value)]="formData.position"
                        [isEditing]="isEditing"
                      ></form-textbox>
                    </div>
                  </dxi-item>

                  <dxi-item cssClass="accent">
                    <div *dxTemplate>
                      <form-textbox
                        label="Assigned to"
                        [(value)]="formData.manager"
                        [isEditing]="isEditing"
                      ></form-textbox>
                    </div>
                  </dxi-item>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" cssClass="contact-fields-group">
                <dxi-item>
                  <div *dxTemplate>
                    <form-textbox
                      icon="tel"
                      mask="+1(000)000-0000"
                      [(value)]="formData.phone"
                      [isEditing]="isEditing"
                    >
                    </form-textbox>
                  </div>
                </dxi-item>
                <dxi-item>
                  <div *dxTemplate>
                    <form-textbox
                      icon="email"
                      [(value)]="formData.email"
                      [isEditing]="isEditing"
                      [isEmail]="true"
                    ></form-textbox>
                  </div>
                </dxi-item>
                <dxi-item>
                  <div *dxTemplate>
                    <form-textbox
                      icon="home"
                      [(value)]="formData.address"
                      [isEditing]="isEditing"
                    >
                    </form-textbox>
                  </div>
                </dxi-item>
              </dxi-item>
            </dx-form>
          </div>

          <div class="data-part data-part-toolbar border">
            <dx-toolbar>
              <dxi-item location="after" [visible]="!isEditing">
                <dx-button
                  text="Edit"
                  icon="edit"
                  stylingMode="contained"
                  type="default"
                  (onClick)="toggleEdit()"
                >
                </dx-button>
              </dxi-item>
              <dxi-item location="after" [visible]="!isEditing">
                <dx-button
                  text="Details"
                  stylingMode="outlined"
                  type="normal"
                  (onClick)="navigateToDetails()"
                >
                </dx-button>
              </dxi-item>
              <dxi-item
                location="after"
                locateInMenu="after"
                [visible]="isEditing"
              >
                <dx-button
                  text="Save"
                  icon="save"
                  stylingMode="contained"
                  type="default"
                  (onClick)="onSaveClick($event)"
                >
                </dx-button>
              </dxi-item>
              <dxi-item
                location="after"
                locateInMenu="after"
                [visible]="isEditing"
              >
                <dx-button
                  text="Cancel"
                  stylingMode="outlined"
                  type="normal"
                  (onClick)="cancelHandler()"
                ></dx-button>
              </dxi-item>
              <dxi-item
                location="before"
                widget="dxDropDownButton"
                [options]="{
                  text: 'Actions',
                  stylingMode: 'text',
                  dropDownOptions: { width: 'auto' },
                  width: 'auto',
                  items: ['Call', 'Send Fax', 'Send Email', 'Make a Meeting']
                }"
              ></dxi-item>
            </dx-toolbar>
          </div>
        </dx-validation-group>

        <div class="data-part">
          <dx-accordion [multiple]="true" [collapsible]="true">
            <div class="accordion-title" *dxTemplate="let t of 'title'">
              <span>{{ t.title }}</span>
            </div>

            <dxi-item title="Opportunities">
              <div *dxTemplate="let i of 'item'">
                <div
                  class="opportunities"
                  *ngFor="let opportunity of formData.opportunities"
                >
                  <span class="value">{{ opportunity.name }} </span>
                  <br />
                  <span class="value black small">{{
                    opportunity.price | currency: 'USD':'$':'1.0-0'
                  }}</span>
                  <br />
                </div>
              </div>
            </dxi-item>

            <dxi-item title="Activities">
              <card-activities [activities]="formData.activities"></card-activities>
            </dxi-item>
          </dx-accordion>
        </div>
      </dx-scroll-view>
    </ng-container>

    <dx-load-panel
      container=".panel"
      [width]="300"
      [visible]="isLoading"
      [showPane]="false"
      [position]="{ of: '.panel' }"
    ></dx-load-panel>
  </div>
</div>
